import RoleType from '../../enums/role-type';

const isAllowedForUser = (requiredRole: RoleType[], userRoles: RoleType[]) =>
	userRoles ? userRoles.some((role: RoleType) => requiredRole.includes(role)) : false;

export default isAllowedForUser;
